import { useEffect, useState } from 'react';

export const useScreenSize = () => {
  const [screen, setScreen] = useState({
    isDesktop: false,
    isTablet: false,
    isMobile: false,
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreen({
        isDesktop: width <= 1200,
        isTablet: width <= 1024,
        isMobile: width <= 576,
        width,
      });
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screen;
};
